// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1OUEP","header":"PatientBlock_header__3lin1","label":"PatientBlock_label__1gmNi","option":"PatientBlock_option__2_w8F"};